import { makeAutoObservable, runInAction } from 'mobx'
import { cloneDeep } from 'lodash'
import agent from '../api/agent'
import { Auction, AuctionBase } from '../models/Auction'
import { store } from './store'
import { history } from '../..'
import { AuctionPublic } from '../models/modes'
import { AuthorizedModInterface, InvitedUserInterface } from '../models/User'

export default class AuctionStore {
  auctionEdit?: Auction = undefined

  constructor() {
    makeAutoObservable(this)
  }

  formatDateLocal = (date: Date) => store.methodsStore.formatDateLocal(date)

  formatDateUtc = (date: Date) => store.methodsStore.formatDateUtc(date)

  setAuctionEdit = async () => {
    const editedAuction: Auction = cloneDeep(store.bidsStore.auctionDetails!)

    if (editedAuction.authorizedMods?.length) {
      editedAuction.authorizedMods = editedAuction.authorizedMods.map((mod) => (mod as AuthorizedModInterface).user.email)
    }

    editedAuction.deadline = new Date(editedAuction.deadline)
    editedAuction.startingDate = new Date(editedAuction.startingDate)
    editedAuction.postId = editedAuction.post?.id
    editedAuction.public = editedAuction.public ? 1 : 0

    if (editedAuction.public === 1) {
      editedAuction.invitedUsers = (editedAuction.invitedUsers as InvitedUserInterface[]).map((user) => user.email) || []
    }

    runInAction(() => {
      this.auctionEdit = editedAuction
    })
  }

  createAuction = async (auctionData: AuctionBase) => {
    const auction = cloneDeep(auctionData)
    auction.minPrice *= 100

    if (auction.startImmediately) {
      auction.startingDate = new Date()
    }
    // Format Dates to Utc
    auction.startingDate = new Date(this.formatDateUtc(auction.startingDate))
    auction.deadline = new Date(this.formatDateUtc(auction.deadline)) 

    if (auction.public === 0) {
      auction.invitedUsers = []
    }

    const { status, data: newAuction } = await agent.Auctions.create(auction)
    // If he doesn't have any free auctions to create then a payment link is made

    if (status === 200) {
      if (newAuction.link) {
        history.push(newAuction.link)
      } else {
        runInAction(() => {
          // Format Dates to Local after creation
          newAuction.startingDate = new Date(this.formatDateLocal(newAuction.startingDate))
          newAuction.deadline = new Date(this.formatDateLocal(newAuction.deadline))
          // todo: change to refetch auction use data
          if (store.userStore.user) {
            store.userStore.user!.auctionUse! -= 1
          }
          
          
          store.methodsStore.setShowCreateAuction(false)
        })
      }
    }
  }

  editAuction = async (data: Auction) => {
    const auction = cloneDeep(data)

    if (auction.startImmediately) {
      auction.startingDate = new Date()
    }

    auction.startingDate = new Date(this.formatDateUtc(auction.startingDate))
    auction.deadline = new Date(this.formatDateUtc(auction.deadline))

    if (!auction.attachment) {
      auction.authorizedMods = []
    }
    if (auction.public === AuctionPublic.Public) {
      auction.invitedUsers = []
    }

    await agent.Auctions.edit(auction)
  }

  deleteAuction = async (id: string) => {
    // const { status, data: newAuction } = await agent.Auctions.create(auction)
    const { status } = await agent.Auctions.del(id)
    if (status === 200) {
      runInAction(() => {
        store.auctionListStore.auctionRegistry.delete(id)
        store.favoriteAuctionsStore.favoriteRegistry.delete(id)
      })
    }
  }
}
